import AbstractRelationshipSelect from './components/AbstractRelationshipSelect';
import AbstractSortDropdown from './components/AbstractSortDropdown';
import ActiveLinkButton from './components/ActiveLinkButton';
import Sortable from './components/Sortable';
import SortableHandle from './components/SortableHandle';
import UserRelationshipSelect from './components/UserRelationshipSelect';
import AbstractShowPage from './pages/AbstractShowPage';
import * as AbstractListState from './states/AbstractListState';
import KeyboardNavigatable from './utils/KeyboardNavigatable';

export const common = {
    'components/AbstractRelationshipSelect': AbstractRelationshipSelect,
    'components/AbstractSortDropdown': AbstractSortDropdown,
    'components/ActiveLinkButton': ActiveLinkButton,
    'components/Sortable': Sortable,
    'components/SortableHandle': SortableHandle,
    'components/UserRelationshipSelect': UserRelationshipSelect,
    'pages/AbstractShowPage': AbstractShowPage,
    'states/AbstractListState': AbstractListState,
    'utils/KeyboardNavigatable': KeyboardNavigatable,
}
